import { createFileRoute } from "@tanstack/react-router";
import { LoginCard } from "@/components/login-card";

export const Route = createFileRoute("/portal/login")({
  ssr: false,
  head: () => ({ meta: [{ title: "Client Portal — Sign in" }] }),
  component: PortalLogin,
});

function PortalLogin() {
  return (
    <LoginCard
      title="Client Portal"
      subtitle="View your shoots, galleries, contracts, and invoices"
      audience="portal"
      allowedRoles={["client_portal"]}
      demoAccounts={[
        { label: "Marcus Halden", email: "jane@client.test" },
        { label: "Sia Agency", email: "sia@client.test" },
        { label: "VOGUE Japan", email: "vogue@client.test" },
      ]}
      redirectTo="/portal"
    />
  );
}
